export const contactsData = {
  email: 'success@769.test',
  userAgreement: true,
  advertisingAgreement: true,
};
